__turbopack_context__.v({
  "button": "MenuList-module__z1m62q__button",
  "menuItem": "MenuList-module__z1m62q__menuItem",
  "name": "MenuList-module__z1m62q__name",
  "selected": "MenuList-module__z1m62q__selected",
});
